import { ReactQuery } from '@/constants/react-query';

export type RetryError = {
	statusCode?: number
};

export type ShouldRetryQueryParams = {
	error:               RetryError
	excludeStatusCodes?: number[]
	failureCount:        number
	maxRetries?:         number
};

// TODO Fix Retry logic and check error response
export function shouldRetryQuery({
	error,
	excludeStatusCodes = [],
	failureCount,
	maxRetries = ReactQuery.MaxRetries,
}: ShouldRetryQueryParams): boolean {
	if (failureCount >= maxRetries) return false;

	const isError = error.statusCode && excludeStatusCodes.includes(error.statusCode);

	return isError ? false : true;
}
